<template>
    <div class="contactus-page">
        <HeaderLanding mode="light" />
        
            <section class="contactus-section">
                <div class="contactus-container">
                    <!-- Badge -->
                    <div class="icon-contactus">
                        <div class="contactus-badge">
                            <img src="@/assets/img/phone-icon.png" alt="codepen" class="icon" />
                            <span class="label">Contact Us</span>
                        </div>
                        <h2 class="contactus-title">Get in Touch with Us</h2>
                    </div>
                </div>
                <div class="contactus-description">
                    <p class="description-text">Have questions about how SurPriz.ing works or how it fits your business? We’re excited to help <br class="desktop-break"/>you create rewarding customer experiences that keep people coming back.</p>
                </div>
            </section>


            <section class="contactus-form">
                <div class="form-container">
                <form @submit.prevent="submitForm">
                    <div class="row">
                    <div class="form-group">
                        <label for="firstName">First Name</label>
                        <input type="text" id="firstName" placeholder="John" v-model="form.firstName" required />
                    </div>
                    <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" id="lastName" placeholder="Doe" v-model="form.lastName" required />
                    </div>
                    </div>

                    <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" id="email" placeholder="johndoe@mail.com" v-model="form.email" required />
                    </div>

                    <div class="form-group">
                    <label for="message">Problem Descriptions</label>
                    <textarea id="message" placeholder="Message" rows="7" v-model="form.message" required></textarea>
                    </div>

                    <div class="form-group checkbox-group">
                    <input type="checkbox" id="checkbox" v-model="form.checked" />
                    <label for="checkbox">Problem Descriptions</label>
                    </div>

                    <div class="form-group">
                    <button type="submit" class="submit-btn">Send Message</button>
                    </div>
                </form>
                </div>
            </section>


            <section class="contactus-wrapper">
                <div class="contactus-info">
                    <div class="contact-card">
                        <div class="card-title-row">
                            <img src="@/assets/img/ChatCircleDots.png" alt="Live Chat Icon" class="icon" />
                            <span class="card-title">Live Chat</span>
                        </div>
                        <p class="card-text">support@chatassist.com</p>
                    </div>
                    <div class="contact-card">
                        <div class="card-title-row">
                            <img src="@/assets/img/PhoneCall.png" alt="Call Icon" class="icon" />
                            <span class="card-title">Call Us</span>
                        </div>
                        <p class="card-text">+1 222 564 4569</p>
                    </div>
                    <div class="contact-card">
                        <div class="card-title-row">
                            <img src="@/assets/img/LocationWhite.png" alt="Location Icon" class="icon" />
                            <span class="card-title">Our Office</span>
                        </div>
                        <p class="card-text">No. 23, Jl. Damai 5, Selangor, Malaysia</p>
                    </div>
                </div>
            </section>

            <section class="asked-questions">
                <div class="faq-container">
                    <!-- Left Column -->
                    <div class="faq-left">
                        <div class="faq-badge">
                            <img src="@/assets/img/codepen.png" alt="codepen" class="icon-square" />
                            <span class="label">FAQs</span>
                        </div>
                        <h2 class="faq-title">Frequently Asked<br />Questions</h2>
                    </div>

                    <!-- Right Column -->
                    <div class="faq-content">
                        <div class="faq-box" :class="{ active: isActive(0) }" @click="toggleBox(0)">
                            <div class="faq-open">
                            <h2>What is SurPriz.ing?</h2>
                            <span class="faq-icon">{{ isActive(0) ? '−' : '+' }}</span>
                            <p v-if="isActive(0)">
                                SurPriz.ing is an AI-powered loyalty and feedback platform that helps small businesses
                                <br />gather customer feedback via QR codes and reward them with digital vouchers or
                                <br />points — no app downloads required.
                            </p>
                            </div>
                        </div>

                        <div class="faq-box" :class="{ active: isActive(1) }" @click="toggleBox(1)">
                            <h2>What features does SurPriz.ing offer?</h2>
                            <span class="faq-icon">{{ isActive(1) ? '−' : '+' }}</span>
                            <p v-if="isActive(1)"></p>
                        </div>

                        <div class="faq-box" :class="{ active: isActive(2) }" @click="toggleBox(2)">
                            <h2>Can it work with my POS system?</h2>
                            <span class="faq-icon">{{ isActive(2) ? '−' : '+' }}</span>
                            <p v-if="isActive(2)"></p>
                        </div>

                        <div class="faq-box" :class="{ active: isActive(3) }" @click="toggleBox(3)">
                            <h2>Is the feedback public?</h2>
                            <span class="faq-icon">{{ isActive(3) ? '−' : '+' }}</span>
                            <p v-if="isActive(3)"></p>
                        </div>

                        <div class="faq-box" :class="{ active: isActive(4) }" @click="toggleBox(4)">
                            <h2>Can my customers share their rewards?</h2>
                            <span class="faq-icon">{{ isActive(4) ? '−' : '+' }}</span>
                            <p v-if="isActive(4)"></p>
                        </div>
                        
                        <button class="more-btn">More Questions</button>
                    
                    </div>
                </div>
                
            </section>


        <FooterLanding />
    </div>
</template>

<script>
import HeaderLanding from '@/components/HeaderLanding.vue';
import FooterLanding from '@/components/FooterLanding.vue';
import bgImage from '@/assets/img/feature-gridbg.png'; // ✅ Add this line

export default {
  name: 'AboutUs',
  components: {
    HeaderLanding,
    FooterLanding,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        message: '',
        checked: false,
      },
      activeIndex: 0, // for FAQ toggle

      // ✅ Add this style binding
      bgStyle: {
        backgroundImage: `linear-gradient(90deg, #C69DFF, #6587FF), url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }
    };
  },
  methods: {
    submitForm() {
      console.log("Submitted", this.form);
    },
    toggleBox(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    isActive(index) {
      return this.activeIndex === index;
    }
  }
};
</script>




<style scoped>


.contactus-page {
    background-color: #FFFFFF;
    box-sizing: border-box;
    min-height: 100vh;
    overflow-x: hidden;
    font-family: 'Inter', sans-serif;
}

.contactus-section {
    background-color: #FFFFFF; /* full width white */
    padding: 96px 120px 80px;
    text-align: center;
}
.contactus-container {
    gap: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* faq icon, h1, p */
.icon-contactus {
    flex: 1;
    min-width: 280px;
    justify-items: center;
}

.contactus-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background-color: #FFFFFF;
    border: 1px solid #dfe1e6;
    border-radius: 6px;
    box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
    font-size: 14px;
    font-weight: 500;
    color: #808897;
    width: fit-content;
    margin-bottom: 16px;
}

.contactus-badge .icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
}

.contactus-title {
    font-size: 48px;
    font-weight: 500;
    color: #111827;
    line-height: 120%;
}


/* contact us form */
.contactus-form {
    display: flex;
    justify-content: center;
}

.form-container {
    background: white;
    padding: 40px;
    width: 700px;
    height: 642px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    margin-bottom: 96px;
}

.row {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    gap: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-bottom: 24px;
}

input[type="text"],
input[type="email"],
textarea {
    border: 1px solid #d0d0d0;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
}

textarea {
    resize: none;
}

.checkbox-group {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    padding-bottom: 40px;
}
.checkbox-group label {
    margin: 0;
}

.submit-btn {
    background-color: #7c6afa;
    color: white;
    padding: 14px 0;
    width: 100%;
    border: none;
    border-radius: 12px;
    font-weight: 500;
    cursor: pointer;
}


/* contact us card */
.contactus-wrapper {
    background: linear-gradient(90deg, #C69DFF, #6587FF);
    padding: 60px 80px;
}

.contactus-info {
    display: flex;
    justify-content: space-between;
    gap: 48px;
    flex-wrap: wrap;
}

.contact-card {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 24px;
    padding: 24px;
    width: 100%;
    max-width: 394px;
    box-sizing: border-box;
    color: white;
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 12px;
}


.icon {
    width: 24px;
    margin-bottom: 8px;
}

.card-title {
    display: block;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 4px;
}

.card-text {
    font-size: 14px;
    opacity: 0.9;
}





/* Asked Questions Section */
.asked-questions {
    background-color: #ffffff;
    padding: 96px 120px 96px;
}

.faq-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 64px;
}

.faq-left {
    flex: 1;
    min-width: 280px;
}

.faq-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background-color: #fff;
    border: 1px solid #dfe1e6;
    border-radius: 6px;
    box-shadow: 0px 1px 2px rgba(13, 13, 18, 0.06);
    font-size: 14px;
    font-weight: 500;
    color: #808897;
    width: fit-content;
    margin-bottom: 16px;
}

.faq-badge .icon-square {
    width: 16px;
    height: 16px;
    margin-right: 6px;
}

.faq-title {
    font-size: 48px;
    font-weight: 500;
    color: #111827;
    line-height: 120%;
}

.faq-content {
    flex: 1.5;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.faq-box {
    position: relative;
    padding: 20px 50px 20px 24px; /* space for icon */
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.faq-box.active {
    background-color: #ffffff20;
    border-radius: 12px;
}

/* .faq-box:hover {
    background-color: #f3f4f6;
} */

.faq-box h2 {
    font-size: 18px;
    font-weight: 600;
    color: #171717;
    line-height: 150%;
    margin-bottom: 8px;
}

.faq-open {
    background-color: #ffffff;
    border-radius: 12px;
}

.faq-open h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    line-height: 150%;
    color: #111827;
}

.faq-open p {
    font-size: 15px;
    font-weight: 400;
    color: #4b5563;
    line-height: 150%;
    margin-top: 12px;
}

.faq-icon {
    position: absolute;
    right: 20px;
    top: 24px;
    font-size: 20px;
    font-weight: 600;
    color: #5B49E9;
    pointer-events: none;
}


/* more button */

.faq-content .more-btn{
    position: relative;
    line-height: 24px;
    font-weight: 600;
    max-width: 170px;
    max-height: 48px;
}

.more-btn {
    position: relative;
    box-shadow: 0px 4px 16px rgba(23, 23, 23, 0.04);
    border-radius: 24px;
    background-color: #1a1a1a;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    box-sizing: border-box;
    text-align: left;
    font-size: 16px;
    color: #fafafa;
}
.desktop-break {
    display: inline;
}

@media (max-width: 768px) {
    
    .desktop-break {
        display: none;
    }
    .contactus-section {
        padding: 48px 24px;
    }
    .contactus-container {
        gap: 16px;
    }
    .contactus-title {
        font-size: 28px;
        font-weight: 600;
    }
    .form-container {
        width: 100%;
        padding: 24px;
    }
    .contactus-info {
        flex-direction: column;
        align-items: center;
        gap: 32px;
    }
    .contact-card {
        width: 100%;
        max-width: none;
    }
    .contactus-wrapper{
        display: none;
    }
    .asked-questions {
        display: none;
    }
}

</style>